import {useDebugValue} from 'react';

import {useTranslations} from './';

const defaultTranslations = {
    labelText: 'Search'
};

function useSubmitTranslations(props) {
    const {
        submitTranslations: propsTranslations
    } = props;

    const {
        translations
    } = useTranslations(defaultTranslations, propsTranslations);

    const result = {
        translations
    };

    useDebugValue(result);

    return result;
}

export {useSubmitTranslations};
